import React, { useState } from "react";
import { connect } from "react-redux";
import { bool } from "prop-types";
import { Col, Row } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";

import { actions as debinActions } from "reducers/debin";

import * as i18n from "util/i18n";

import { useTransaction } from "hooks/useTransactions";
import { transactionStatus } from "pages/transactions/constants";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import Notification from "pages/_components/Notification";
import { ResponsiveHeader } from "pages/_components/header";
import Avatar from "pages/_components/Avatar";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomData from "pages/_components/CustomData/CustomData";
import GridTable from "pages/_components/GridTable/GridTable";
import {
    TransactionCard,
    TransactionHeader,
    TransactionInfo,
    TransactionSign,
} from "pages/_components/TransactionCard";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";

const ActionTransactionPage = ({ isDesktop }) => {
    const { pathname } = useLocation();
    const { action } = useParams();
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const formatTransaction = (data, idTransaction) => {
        const formData = {
            idTransaction,
            ...data.scheduledDebin,
        };

        return { ...formData };
    };
    const { transaction, dispatch, handleSignTransaction, showSignButton, push, id } = useTransaction(
        `/scheduledDebin/action/${action}`,
        debinActions.setScheduledDebin,
        null,
        formatTransaction,
    );

    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        `activities.debin.scheduled.${action}.send`,
        id,
        "debin",
    );

    const isBackoffice = pathname.includes("backoffice");
    const transactionData = {
        accountNumber: transaction?.data?.scheduledDebin.buyer.shortLabel || "",
        currency: transaction?.data?.scheduledDebin.debin.amount.currency || "",
        quantity: transaction?.data?.scheduledDebin.debin.amount.quantity || 0,
        username: transaction?.data?.username || "",
        concept: transaction?.data?.scheduledDebin.debin.concept || "",
        reference: transaction?.data?.scheduledDebin.debin.reference || "",
        installmentLimit: transaction?.data?.scheduledDebin.debin.installmentLimit || "",
        benefit: transaction?.data?.scheduledDebin.debin.benefit || "",
        creationDate: transaction?.data?.scheduledDebin.creationDate || "",
    };
    const isFinished = transactionStatus.FINISHED === transaction.idTransactionStatus;
    const isFailed = transactionStatus.FAILED === transaction.idTransactionStatus;
    const isCancelled = transactionStatus.CANCELLED === transaction.idTransactionStatus;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
    };

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="debin" />
            {!isBackoffice && <ResponsiveHeader ticket metaTitle={`activities.debin.scheduled.${action}.send`} />}
            <MainContainer showLoader={!transaction.data}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title={`activities.debin.scheduled.${action}.send`} />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <div className="ticket__body echeq-massive-emit">
                                        <div className="ticket-header-info">
                                            <div style={{ alignItems: "center" }}>
                                                <div
                                                    className="grid-table-data flex align-items-end"
                                                    style={{ flexDirection: "row" }}>
                                                    {isDesktop && (
                                                        <Avatar
                                                            user={{
                                                                userFullName: transactionData.username,
                                                                defaultAvatarId: 0,
                                                            }}
                                                        />
                                                    )}
                                                    <div
                                                        className="custom-data"
                                                        style={{ textAlign: "start", marginLeft: "5px" }}>
                                                        <CustomText
                                                            textType="I18N"
                                                            text="creditBill.cuit.label"
                                                            className="custom-data-title"
                                                        />
                                                        <span className="custom-text custom-data-value">
                                                            {transactionData.username}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <CustomData
                                                dataClass={`amount tag tag-${transaction.idTransactionStatus}`}
                                                titleText="debin.scheduled.acceptReject.totalAmount"
                                                titleTextType="I18N"
                                                valueText={
                                                    <FormattedAmount
                                                        currency={transactionData.currency}
                                                        quantity={
                                                            Number(transactionData.quantity) *
                                                            Number(transactionData.installmentLimit)
                                                        }
                                                    />
                                                }
                                            />
                                        </div>

                                        <div className="view-more-data-button" id="element-to-ignore">
                                            <div className="ticket__divider inside-ticket__body">
                                                <div className="ticket__notch ticket__notch--left"> </div>
                                                <div className="ticket__notch ticket__notch--right"> </div>
                                            </div>
                                            <Button
                                                aria-expanded={showMoreData ? "true" : "false"}
                                                className="more-button"
                                                label={showMoreData ? "echecks.seeLess.button" : "transfers.showMore"}
                                                bsStyle="link"
                                                onClick={handleSeeMoreData}
                                                image={
                                                    showMoreData
                                                        ? "figma/icon/arrow-up.svg"
                                                        : "figma/icon/arrow-down.svg"
                                                }
                                            />

                                            <div
                                                className={`view-more-data full-width view-discounts-echeq ${
                                                    showMoreData ? "expand " : "collapse"
                                                }`}>
                                                <GridTable className="equivalent-total-balance">
                                                    <GridTable.Container columnsTemplate="fixed" columns={2}>
                                                        <GridTable.Data rowStart={1} columnStart={1}>
                                                            <TransactionInfo
                                                                field="debin.scheduled.acceptReject.debitAccount"
                                                                value={`····${transactionData.accountNumber}`}
                                                            />
                                                        </GridTable.Data>
                                                        <GridTable.Data
                                                            rowStart={isDesktop ? 1 : 2}
                                                            columnStart={isDesktop ? 2 : 1}>
                                                            <TransactionInfo
                                                                field="debin.scheduled.acceptReject.amount"
                                                                value={
                                                                    <FormattedAmount
                                                                        currency={transactionData.currency}
                                                                        quantity={transactionData.quantity}
                                                                    />
                                                                }
                                                            />
                                                        </GridTable.Data>
                                                        <GridTable.Data rowStart={isDesktop ? 2 : 3} columnStart={1}>
                                                            <TransactionInfo
                                                                field="debin.scheduled.acceptReject.concept"
                                                                value={transactionData.concept}
                                                            />
                                                        </GridTable.Data>
                                                        <GridTable.Data
                                                            rowStart={isDesktop ? 2 : 4}
                                                            columnStart={isDesktop ? 2 : 1}>
                                                            <TransactionInfo
                                                                field="debin.scheduled.acceptReject.reference"
                                                                value={transactionData.reference}
                                                            />
                                                        </GridTable.Data>
                                                        <GridTable.Data rowStart={isDesktop ? 3 : 5} columnStart={1}>
                                                            <TransactionInfo
                                                                field="debin.scheduled.acceptReject.numberOfInstallments"
                                                                value={transactionData.installmentLimit}
                                                            />
                                                        </GridTable.Data>
                                                        <GridTable.Data
                                                            rowStart={isDesktop ? 3 : 6}
                                                            columnStart={isDesktop ? 2 : 1}>
                                                            <TransactionInfo
                                                                field="debin.scheduled.acceptReject.benefit"
                                                                value={transactionData.benefit}
                                                            />
                                                        </GridTable.Data>
                                                        <GridTable.Data rowStart={isDesktop ? 4 : 7} columnStart={1}>
                                                            <TransactionInfo
                                                                field="debin.scheduled.acceptReject.startDate"
                                                                value={
                                                                    <FormattedDate
                                                                        showTime={false}
                                                                        date={transactionData.creationDate}
                                                                    />
                                                                }
                                                            />
                                                        </GridTable.Data>
                                                    </GridTable.Container>
                                                </GridTable>
                                                <TransactionSign
                                                    hasVaucher
                                                    isDesktop={isDesktop}
                                                    noDate
                                                    isSmall
                                                    creationTime
                                                    showMoreData={showMoreData}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                </div>

                {!isBackoffice && (
                    <Row className="form-actions">
                        <Col xs={12} md={4} mdOffset={showSignButton || isFinished || isCancelled || isFailed ? 2 : 4}>
                            <Button
                                onClick={() => dispatch(push("/desktop"))}
                                label="forms.transaction.ticket.actions.backToHome"
                                className={`btn${
                                    isFinished || isCancelled || isFailed ? " btn-outline" : " btn-primary"
                                }`}
                            />
                        </Col>
                        {(isFinished || isCancelled || isFailed) && (
                            <>
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleDownload}
                                        label="global.download"
                                        className="btn btn-primary"
                                        image="images/download.svg"
                                    />
                                </Col>
                                {!isDesktop && (
                                    <Col xs={12} md={4}>
                                        <Button
                                            className="btn btn-outline"
                                            image="images/figma/icon/share.svg"
                                            label="global.share"
                                            onClick={() => {
                                                handleShareMobile();
                                            }}
                                        />
                                    </Col>
                                )}
                            </>
                        )}
                        {showSignButton && (
                            <Col xs={12} md={4}>
                                <Button
                                    onClick={handleSignTransaction}
                                    label="forms.signTransaction.link"
                                    className="btn btn-primary"
                                />
                            </Col>
                        )}
                    </Row>
                )}
            </MainContainer>
        </>
    );
};

ActionTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default connect()(ActionTransactionPage);
